/**
 * The collapsed keyword cloud shows a chosen subset, not the front of the
 * sorted list. Unused tags sort A–Z, so the front is always the same letters.
 * `showAll` and a missing limit return the full list.
 */
export const visibleKeywords = <T extends { id: string }>(
  tags: readonly T[],
  limit: number | undefined,
  showAll: boolean,
  previewIds: readonly string[]
): readonly T[] => {
  if (limit == null || showAll || tags.length <= limit) return tags

  const byId = new Map(tags.map((tag) => [tag.id, tag]))
  return previewIds.flatMap((id) => {
    const tag = byId.get(id)
    return tag ? [tag] : []
  })
}
